import React from 'react'
import { useHistory } from 'react-router-dom'

import { Icon, icons, Button } from '../components/ui-blocks'


export const Page404 = () => {

  const history = useHistory()


  const redirectHome = () => {
    if (history) {
      history.replace(process.env.PUBLIC_URL)
    }
  }


  return (
    <div className="mt-5 mx-auto text-center">

      <Icon icon={icons.fileSearch} className="display-4 mb-4 text-muted" />

      <h1 className="mb-3">Nothing here</h1>
      <p className="mb-4 text-muted">
        That page does not exist, or it moved.
      </p>

      <Button onClick={redirectHome} className="px-4">
        Back to your dashboard
      </Button>

    </div>
  )

}
